import type { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

const EXPIRE_TOKEN_TIME = 8; // Token Expire time limit

const timeDiff = (date1: Date, date2: Date): number => {
  const msec = date2.getTime() - date1.getTime();
  return Math.floor(msec / 1000 / 60 / 60);
};

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    headers.set('Authorization', `Bearer ${localStorage.getItem('idToken')}`);
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, any, FetchBaseQueryMeta> = async (
  args,
  api,
  extraOptions,
) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result && result.error?.status === 403) {
    try {
      const auth = getAuth();

      onAuthStateChanged(auth, async (user) => {
        if (user) {
          if (!localStorage.getItem('tokenStoreTime')) localStorage.setItem('tokenStoreTime', new Date().getTime().toString());

          const storeTime = new Date(Number(localStorage.getItem('tokenStoreTime') || 0));
          const diffHours = timeDiff(new Date(storeTime), new Date());

          if (diffHours < EXPIRE_TOKEN_TIME) {
            const token = await user.getIdToken(true);

            localStorage.setItem('idToken', token);
            result = await baseQuery(args, api, extraOptions);
            return result;
          }
        }

        window.location.href = '/signout';
        return result;
      });
    } catch (err) {
      console.log(err);
    }
  }

  return result;
};

export { baseQueryWithReauth };
